import { useMutation, useQueryClient } from "@tanstack/react-query";

import { client } from "@/config/client";

export const useAddRole = function (model, id) {
  const queryClient = useQueryClient();

  const mutationFn = (role) => {
    return client[model].addRole(id, role);
  };

  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: [model, "list"] });
    queryClient.invalidateQueries({ queryKey: [model, "get", parseInt(id)] });
  };

  return useMutation({
    mutationFn,
    onSuccess,
  });
};
